import React, { useState, useEffect } from 'react';
import { State, City } from 'country-state-city';
import { SZType, NewProperty, ZSections, CategoryFilterMaster, HeroSection, BannerSection, PageBanner, WEBFAQ, TrustedPartnerURL, TestimonialURL, StateURL, CityURL } from './APIUrls';

const checkUserIsLogin = () => {
    const username = JSON.parse(localStorage.getItem('username'));
    const email = JSON.parse(localStorage.getItem('email'));
    const id = JSON.parse(localStorage.getItem('id'));
    const tcn = JSON.parse(localStorage.getItem('tcn'));
    if (username && email && id && tcn) {
        return true;
    }
    return false;
}

const useStates = () => {
    const [states, setStates] = useState([]);
    useEffect(() => {
        const allStates = State.getStatesOfCountry("IN");
        const statenames = allStates.filter((state) => state.isoCode === "HR");
        statenames.unshift({ name: "Select", isoCode: "0" });
        setStates(statenames);
    }, []);
    return states;
};

const useCities = (stateCode) => {
    const [cities, setCities] = useState([]);
    useEffect(() => {
        if (!stateCode) {
            setCities([]);
            return;
        }
        const allCities = City.getCitiesOfState("IN", stateCode);
        allCities.unshift({ name: "Select", isoCode: "0" });
        setCities(allCities);
    }, [stateCode]);
    return cities;
}



const getAllHeroTitlenandSubtitle = async () => {
    try {
        const response = await fetch(HeroSection + 'GetAllHeroSectionWeb', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            let filterdata = result.data.filter(item => item.IsActive == true);
            localStorage.setItem('HeroSectionListforWeb', JSON.stringify(filterdata));
            return filterdata;
        }
    } catch (error) {
        console.log(error);
    }
};





const GetAllSZTypeforWeb = async () => {
    try {
        const response = await fetch(SZType + 'GetAllSZTypeforWeb', {
            method: "POST",
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('tcn')),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            let filterdata = result.data.filter(item => item.IsActive == true);
            // localStorage.setItem('SZTypeListforWeb', JSON.stringify(filterdata));
            return filterdata;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllPropertyTypesforWeb = async () => {
    try {
        let propertytype = JSON.parse(localStorage.getItem('SZTypeListforWeb'));
        if (!propertytype) {
            propertytype = await GetAllSZTypeforWeb();
        }

        propertytype = propertytype.filter(item => item.SectionId == 11 || item.SectionId == 12).sort((a, b) => a.TypeId - b.TypeId);
        // propertytype = propertytype.map(item => ({ TypeId: item.TypeId, TypeName: item.TypeId == 103 ? item.TypeName + "s | Residential" : item.TypeId == 116 ? item.TypeName + "s | Commercial" : item.TypeName }));
        propertytype.unshift({ TypeId: 0, TypeName: "View All" });
        localStorage.setItem('AllPropertyTypesforWeb', JSON.stringify(propertytype));
        return propertytype;

    } catch (error) {
        console.log(error);
    }
};

const GetAllZSectionforWeb = async () => {
    try {
        //debugger
        const response = await fetch(ZSections + 'GetAllZSectionsforWeb', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            let filterdata = result.data; //.filter(item => item.IsActive==true);
            localStorage.setItem('ZSectionsListforWeb', JSON.stringify(filterdata));
            return filterdata;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllCategoryFilterMasterforWeb = async () => {
    try {
        const response = await fetch(CategoryFilterMaster + 'GetAllCategoryFilterMasterforWeb', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            let filterdata = result.data.filter(item => item.IsActive == true);
            localStorage.setItem('CategoryFilterMasterListforWeb', JSON.stringify(filterdata));
            return filterdata;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllPropertyforWeb = async (enqueueSnackbar) => {

    try {

        const response = await fetch(NewProperty + "GetAllNewPropertyforWeb", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({}),
        });

        debugger;
        if (!response.ok) {
            throw new Error(`Server error: ${response.status}`);
        }

        const text = await response.text();
        if (!text || text.trim() === "") {
            throw new Error("Server returned an empty response");
        }

        const result = JSON.parse(text);

        if (result.Message == "Success") {
            result.data = result.data.filter(x => x.PropertyFor != "Rented" && x.PropertyFor != "Sold" && x.PropertyFor != "PG Rented");
            localStorage.setItem('AllPropertiesforWeb', JSON.stringify(result.data));
            localStorage.setItem('AllFeaturedPropertiesforWeb', JSON.stringify(result.data.filter(item => item.IsFeatured === true).sort((a, b) => b.PropertyId - a.PropertyId)));
            localStorage.setItem('TopandLatest_8_PropertiesforWeb', JSON.stringify(result.data.sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn)).slice(0, 8)));
            localStorage.setItem('TimeStampforData', JSON.stringify(new Date().getTime() + 10 * 60 * 1000));

            return result.data;
        }
        throw new Error("Failed to retrieve property data");
    } catch (error) {
        console.error("Error fetching properties:", error);
        if (enqueueSnackbar) {
            enqueueSnackbar("Error fetching properties. Please try again.", { variant: "error" });
        }
    }
};

const GetAllPageBannerforWeb = async () => {
    const getCachedBanners = () => {
        try {
            const cached = JSON.parse(localStorage.getItem('PageBannerListforWeb') || '[]');
            return Array.isArray(cached) ? cached : [];
        } catch (error) {
            return [];
        }
    };

    try {
        const response = await fetch(PageBanner + 'GetAllPageBannerforWeb', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
        }

        const result = await response.json();
        const rows = result?.data || result?.Data || [];
        const filterdata = Array.isArray(rows) ? rows.filter(item => item?.IsActive !== false) : [];

        if (!filterdata.length) {
            return getCachedBanners();
        }

        localStorage.setItem('PageBannerListforWeb', JSON.stringify(filterdata));
        return filterdata;
    } catch (error) {
        console.error('GetAllPageBannerforWeb error:', error);
        return getCachedBanners();
    }
};

const GetAllWEBFAQforWeb = async () => {
    try {
        const response = await fetch(WEBFAQ + 'GetAllWEBFAQforWeb', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
        }

        const result = await response.json();
        const rows = result?.data || result?.Data || [];
        return Array.isArray(rows) ? rows : [];
    } catch (error) {
        console.error('GetAllWEBFAQforWeb error:', error);
        return [];
    }
};

const GetAllTrustedPartnerforWeb = async () => {
    const getCachedPartners = () => {
        try {
            const cached = JSON.parse(localStorage.getItem('TrustedPartnerListforWeb') || '[]');
            return Array.isArray(cached) ? cached : [];
        } catch (error) {
            return [];
        }
    };

    try {
        const response = await fetch(TrustedPartnerURL + 'GetAllTrustedPartnerforWeb', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
        }

        const result = await response.json();
        const rows = result?.data || result?.Data || [];
        const filterdata = Array.isArray(rows)
            ? rows.filter(item => item?.IsActive !== false && !!item?.Logo)
            : [];

        if (!filterdata.length) {
            return getCachedPartners();
        }

        localStorage.setItem('TrustedPartnerListforWeb', JSON.stringify(filterdata));
        return filterdata;
    } catch (error) {
        console.error('GetAllTrustedPartnerforWeb error:', error);
        return getCachedPartners();
    }
};

const GetAllTestimonialforWeb = async () => {
    const getCachedTestimonials = () => {
        try {
            const cached = JSON.parse(localStorage.getItem('TestimonialListforWeb') || '[]');
            return Array.isArray(cached) ? cached : [];
        } catch (error) {
            return [];
        }
    };

    try {
        const response = await fetch(TestimonialURL + 'GetAllTestimonialforWeb', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
        }

        const result = await response.json();
        const rows = result?.data || result?.Data || [];
        const filterdata = Array.isArray(rows)
            ? rows.filter(item => item?.IsActive !== false)
            : [];

        if (!filterdata.length) {
            return getCachedTestimonials();
        }

        localStorage.setItem('TestimonialListforWeb', JSON.stringify(filterdata));
        return filterdata;
    } catch (error) {
        console.error('GetAllTestimonialforWeb error:', error);
        return getCachedTestimonials();
    }
};


const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Earth's radius in km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};

const fnGetFilteredPropertiesUsingLocation = (currentLatitude, currentLongitude, propertiesData) => {
    const RADIUS_KM = 50;

    try {
        let properties = propertiesData;

        // Validate propertiesData
        if (!properties || !Array.isArray(properties) || properties.length === 0) {
            properties = JSON.parse(localStorage.getItem('AllPropertiesforWeb')) || [];
        }

        if (!properties.length) {
            return [];
        }

        const filteredProperties = properties.filter(property => {
            if (!property.Latitude || !property.Longitude) {
                return false;
            }
            const distance = calculateDistance(currentLatitude, currentLongitude, property.Latitude, property.Longitude);
            return distance <= RADIUS_KM;
        }).map(property => ({
            ...property,
            distance: calculateDistance(currentLatitude, currentLongitude, property.Latitude, property.Longitude)
        })).sort((a, b) => a.distance - b.distance);

        return filteredProperties;
    } catch (error) {
        console.error("Error filtering properties by location:", error);
        return [];
    }
};

const fnGetFilteredpropertiesUsingKeyword = (keyword, propertiesData) => {
    try {
        let properties = propertiesData;

        // Validate propertiesData
        if (!properties || !Array.isArray(properties) || properties.length === 0) {
            properties = JSON.parse(localStorage.getItem('AllPropertiesforWeb')) || [];
        }
        if (!properties.length) {
            return [];
        }
        const filteredProperties = properties.filter(property => {
            const lowerKeyword = keyword.toLowerCase();
            return property.PropertyTitle.toLowerCase().includes(lowerKeyword) ||
                property.PropertyDescription.toLowerCase().includes(lowerKeyword) ||
                property.Address.toLowerCase().includes(lowerKeyword) ||
                property.City.toLowerCase().includes(lowerKeyword) ||
                property.State.toLowerCase().includes(lowerKeyword) ||
                property.ProjectBuilderCompanyName.toLowerCase().includes(lowerKeyword) ||
                property.PropertyTypeName.toLowerCase().includes(lowerKeyword) ||
                property.ConstructionStatusName.toLowerCase().includes(lowerKeyword) ||
                property.PropertyLabelName.toLowerCase().includes(lowerKeyword);
        }).sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));

        return filteredProperties;
    } catch (error) {
        console.error("Error filtering properties by keyword:", error);
        return [];
    }
};


const fnGetFilteredPropertiesusingLocationName = (locationName, propertiesData) => {
    try {
        let properties = propertiesData;
        // Validate propertiesData
        if (!properties || !Array.isArray(properties) || properties.length === 0) {
            properties = JSON.parse(localStorage.getItem('AllPropertiesforWeb')) || [];
        }
        if (!properties.length) {
            return [];
        }
        const lowerLocationName = (locationName || '').toLowerCase().trim();

        if (!lowerLocationName) {
            return properties.sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));
        }

        const filteredProperties = properties.filter(property => {
            const searchableValues = [
                property.Address,
                property.AreaIncluding,
                property.Area,
                property.CityName,
                property.City,
                property.StateName,
                property.State,
            ]
                .filter(Boolean)
                .map((value) => value.toString().toLowerCase());

            return searchableValues.some((value) => value.includes(lowerLocationName));
        }).sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));

        return filteredProperties;
    } catch (error) {
        console.error("Error filtering properties by location name:", error);
        return [];
    }
};

const fnGetFilteredPropertiesonStatusSaleorRent = (status, propertiesData) => {
    try {

        let properties = propertiesData;
        // Validate propertiesData
        if (!properties || !Array.isArray(properties) || properties.length === 0) {
            properties = JSON.parse(localStorage.getItem('AllPropertiesforWeb')) || [];
        }

        if (!properties.length) {
            return [];
        }
        const filteredProperties = properties.filter(property => property.StatusName.toLowerCase() === status.toLowerCase())
            .sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));
        return filteredProperties;
    }
    catch (error) {
        console.error("Error filtering properties by Sale/Rent status:", error);
        return [];
    }
};

const fnGetConsolidateandUniqueProperties = (propertiesData) => {
    try {
        let properties = propertiesData;
        const uniqueProperties = [];
        const seenPropertyIds = new Set();

        properties.forEach(property => {
            if (!seenPropertyIds.has(property.PropertyId)) {
                seenPropertyIds.add(property.PropertyId);
                uniqueProperties.push(property);
            }
        });

        return uniqueProperties;
    } catch (error) {
        console.error("Error consolidating and making properties unique:", error);
        return [];
    }
};

const fnGetFilteredPropertiesUsingBedRoom = (bedrooms, propertiesData) => {
    try {
        let properties = propertiesData;
        // Validate propertiesData
        if (!properties || !Array.isArray(properties) || properties.length === 0) {
            properties = JSON.parse(localStorage.getItem('AllPropertiesforWeb')) || [];
        }

        if (!properties.length) {
            return [];
        }

        if (bedrooms == "All")
            return properties.sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));

        const filteredProperties = properties.filter(property => {
            return property.BedRoomQuantities == bedrooms;
        }).sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));

        return filteredProperties;
    } catch (error) {
        console.error("Error filtering properties by bedroom count:", error);
        return [];
    }
};

const fnGetFilteredPropertiesUsingBathRoom = (bathrooms, propertiesData) => {
    try {
        let properties = propertiesData;
        // Validate propertiesData
        if (!properties || !Array.isArray(properties) || properties.length === 0) {
            properties = JSON.parse(localStorage.getItem('AllPropertiesforWeb')) || [];
        }
        if (!properties.length) {
            return [];
        }
        if (bathrooms == "All")
            return properties.sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));


        const filteredProperties = properties.filter(property => {
            return property.BathRoomQuantities == bathrooms;
        }
        ).sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));

        return filteredProperties;
    } catch (error) {
        console.error("Error filtering properties by bathroom count:", error);
        return [];
    }
};

const fnGetFilteredPropertiesUsingAreaRange = (areaRange, propertiesData) => {
    try {
        let properties = propertiesData;
        // Validate propertiesData
        if (!properties || !Array.isArray(properties) || properties.length === 0) {
            properties = JSON.parse(localStorage.getItem('AllPropertiesforWeb')) || [];
        }
        if (!properties.length) {
            return [];
        }
        const minArea = areaRange[0];
        const maxArea = areaRange[1];

        const filterminArea = properties.filter(property => {
            const area = Number(property.ConstructedArea);
            return minArea <= area;
        }).sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));

        const filteredProperties = filterminArea.filter(property => {
            const area = Number(property.ConstructedArea);
            return maxArea >= area;
        }).sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));

        const check = 0;


        return filteredProperties;
    } catch (error) {
        console.error("Error filtering properties by area range:", error);
        return [];
    }
};

const fnGetFilteredPropertiesUsingConstructionStatus = (constructionStatus, propertiesData) => {
    try {
        let properties = propertiesData;
        // Validate propertiesData
        if (!properties || !Array.isArray(properties) || properties.length === 0) {
            properties = JSON.parse(localStorage.getItem('AllPropertiesforWeb')) || [];
        }
        if (!properties.length) {
            return [];
        }
        if (constructionStatus == "All")
            return properties.sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));
        const filteredProperties = properties.filter(property => {
            return property.ConstructionStatusName.toLowerCase() === constructionStatus.toLowerCase();
        }).sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));
        return filteredProperties;
    } catch (error) {
        console.error("Error filtering properties by construction status:", error);
        return [];
    }
};

const fnGetFilteredPropertiesUsingPropertyCategory = (propertyCategory, propertiesData) => {
    try {
        let properties = propertiesData;
        // Validate propertiesData
        if (!properties || !Array.isArray(properties) || properties.length === 0) {
            properties = JSON.parse(localStorage.getItem('AllPropertiesforWeb')) || [];
        }
        if (!properties.length) {
            return [];
        }
        if (propertyCategory == "All")
            return properties.sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));

        const filteredProperties = properties.filter(property => {
            return property.PropertyLabelName.toLowerCase() === propertyCategory.toLowerCase();
        }).sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));
        return filteredProperties;
    } catch (error) {
        console.error("Error filtering properties by property category:", error);
        return [];
    }
};




const fnGetFilteredPropertiesUsingPropertyType = (propertyType, propertiesData) => {
    try {
        let properties = propertiesData;
        // Validate propertiesData
        if (!properties || !Array.isArray(properties) || properties.length === 0) {
            properties = JSON.parse(localStorage.getItem('AllPropertiesforWeb')) || [];
        }
        if (!properties.length) {
            return [];
        }
        if (propertyType == "All")
            return properties.sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));

        const filteredProperties = properties.filter(property => {
            return property.PropertyTypeName.toLowerCase() === propertyType.toLowerCase();
        }).sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));
        return filteredProperties;
    } catch (error) {
        console.error("Error filtering properties by property type:", error);
        return [];
    }
};


const fnGetFilteredPropertiesUsingPriceRange = (priceRange, propertiesData) => {
    try {
        let properties = propertiesData;
        // Validate propertiesData
        if (!properties || !Array.isArray(properties) || properties.length === 0) {
            properties = JSON.parse(localStorage.getItem('AllPropertiesforWeb')) || [];
        }
        if (!properties.length) {
            return [];
        }
        const minPrice = priceRange[0];
        const maxPrice = priceRange[1];
        const filteredProperties = properties.filter(property => {
            const price = Number(property.PropertyPrice);
            return minPrice <= price && maxPrice >= price;
        }).sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn));
        return filteredProperties;
    } catch (error) {
        console.error("Error filtering properties by price range:", error);
        return [];
    }
};


const getCoordinates = () => {
    if (!navigator.geolocation) {
        console.error("Geolocation is not supported by your browser");
        return;
    }

    navigator.geolocation.getCurrentPosition(
        (position) => {
            const { latitude, longitude } = position.coords;
            return { latitude, longitude };
        },
        (error) => {
            console.error(`Geolocation error: ${error.message}`);
        },
        { enableHighAccuracy: true }
    );
};

const FullScreenLoader = ({ isLoading, message = "Filtering nearby properties..." }) => {
    if (!isLoading) return null;

    return (
        <div className="fullscreen-loader-overlay">
            <div className="loader-container">
                <div className="spinner"></div>
                {/* <p className="loader-text">{message}</p> */}
            </div>
        </div>
    );
};


export {
    checkUserIsLogin,
    useStates,
    useCities,
    getAllHeroTitlenandSubtitle,
    GetAllSZTypeforWeb,
    GetAllZSectionforWeb,
    GetAllCategoryFilterMasterforWeb,
    GetAllPropertyTypesforWeb,
    GetAllPropertyforWeb,
    GetAllPageBannerforWeb,
    GetAllWEBFAQforWeb,
    GetAllTrustedPartnerforWeb,
    GetAllTestimonialforWeb,
    fnGetFilteredPropertiesUsingLocation,
    getCoordinates,
    FullScreenLoader,
    fnGetFilteredpropertiesUsingKeyword,
    fnGetFilteredPropertiesusingLocationName,
    fnGetConsolidateandUniqueProperties,
    fnGetFilteredPropertiesonStatusSaleorRent,
    fnGetFilteredPropertiesUsingBedRoom,
    fnGetFilteredPropertiesUsingBathRoom,
    fnGetFilteredPropertiesUsingAreaRange,
    fnGetFilteredPropertiesUsingPriceRange,
    fnGetFilteredPropertiesUsingPropertyType,
    fnGetFilteredPropertiesUsingConstructionStatus,
    fnGetFilteredPropertiesUsingPropertyCategory,

};